










































import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';
type SelectOptionType = object | string | number;

export default defineComponent({
  name: 'Select',
  props: {
    items: {
      type: Array as PropType<SelectOptionType[]>,
      required: true
    },
    default: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: [Object, String, Number] as PropType<SelectOptionType>,
      required: false
    },
    itemText: {
      type: String,
      required: false
    },
    itemValue: {
      type: String,
      required: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    hideSelectionCheckmark: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const isOpen = ref(false);
    const optionList = ref(null);
    const selectButton = ref(null);

    const select = (item: object | string | number): void => {
      isOpen.value = false;
      context.emit(
        'input',
        props.returnObject || !props.itemValue ? item : item[props.itemValue]
      );
    };

    const toggleOpen = (): void => {
      if (!isOpen.value) {
        if (
          optionList.value.offsetHeight +
            selectButton.value.getBoundingClientRect().bottom +
            8 >
          window.innerHeight
        ) {
          optionList.value.style.bottom = '100%';
          optionList.value.style.top = 'initial';
        } else {
          optionList.value.style.top = '100%';
          optionList.value.style.bottom = 'initial';
        }
      }
      isOpen.value = !isOpen.value;
    };

    return {
      isOpen,
      optionList,
      selectButton,
      toggleOpen,
      select
    };
  }
});
